import { useEffect } from 'react';
import { useQueryPanelStore } from '@/stores/query-panel.store';
import { useSourcesStore } from '@/stores/sources.store';
import { useQueryFiltersStore } from '@/stores/query-filters.store';

export function useResetQueryState() {
    useEffect(() => {
        useQueryPanelStore.getState().reset();
        useSourcesStore.getState().clearSelection();
        useQueryFiltersStore.getState().resetFilters();
    }, []);
}
